import { render } from "./AppCommunicationsMenuTree.vue?vue&type=template&id=69da836b&scoped=true"
import script from "./AppCommunicationsMenuTree.vue?vue&type=script&lang=js"
export * from "./AppCommunicationsMenuTree.vue?vue&type=script&lang=js"

import "./AppCommunicationsMenuTree.vue?vue&type=style&index=0&id=69da836b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69da836b"]])

export default __exports__